import { useState } from 'react';

import { Popover } from '@mantine/core';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DesktopNavigationDropdownOnClick: FunctionComponent<Props> = ({
    children,
    className = '',
    dropdownElement,
    testId = TEST_ID
}) => {
    const [open, setOpen] = useState(false);

    return (
        <Popover
            closeOnClickOutside
            closeOnEscape
            onChange={setOpen}
            opened={open}
            portalProps={{ target: document.body }}
            withinPortal={true}
        >
            <Popover.Target>
                <span
                    className={`${styles.desktopNavigationDropdown} ${className}`}
                    data-testid={testId}
                    onClick={() => setOpen(prev => !prev)}
                >
                    {dropdownElement}
                </span>
            </Popover.Target>

            <Popover.Dropdown className={styles.dropdownContent} onClick={() => setOpen(false)}>
                {children}
            </Popover.Dropdown>
        </Popover>
    );
};

export default DesktopNavigationDropdownOnClick;
